import { useExtractVideoFromId } from 'api';
import { ChangeEvent, useEffect, useState } from 'react';
import { CreativeVideo } from '../../../../../types';
import { Severity, usePushNotifications } from 'services/NotificationService';
import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';

export const useVideoExtractor = () => {
  const store = useCreativeTemplatesBuilderStore();
  const notify = usePushNotifications();
  const [videoId, setVideoId] = useState<string>('');

  const [extractVideo, { data, loading }] = useExtractVideoFromId();

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => setVideoId(event.target.value);

  const handleVideoExtraction = () => {
    try {
      setVideoId('');
      extractVideo({ variables: { videoId } });
    } catch (e) {
      notify({ title: 'Failed to extract video', message: e.message, severity: Severity.ERROR });
    }
  };

  useEffect(() => {
    if (!data) return;
    if (data.extractVideoFromId.errors) {
      notify({
        title: 'Failed to extract video',
        message: data.extractVideoFromId.errors,
        severity: Severity.ERROR
      });
      return;
    }
    store.setVideos([...store.videos, data.extractVideoFromId.video as CreativeVideo]);
  }, [data]);

  return { videoId, handleChange, handleVideoExtraction, loading };
};
